
import React from 'react';
import { Card, CardHeader, CardContent, CardTitle } from '@/components/ui/card';

const NoTelemetryData: React.FC = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Telemetry Dashboard</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex justify-center items-center h-40">
          <p className="text-muted-foreground">No telemetry data available</p>
        </div>
      </CardContent>
    </Card>
  );
};

export default NoTelemetryData;
